// extracted by mini-css-extract-plugin
module.exports = {"commentForm":"CommentInput_commentForm__1fZPf","commentInputContainer":"CommentInput_commentInputContainer__30-CJ","commentButton":"CommentInput_commentButton__3fJYz"};